export default {
	emits: [],

  props: {},

	methods: {},
}